import { useFormContext } from 'react-hook-form';

import { Button, ButtonProps } from 'components/Blocks';

import { AnyObject, StableOmit } from 'types';

export type SubmitFormButtonProps<T extends AnyObject = AnyObject> = StableOmit<
  ButtonProps,
  'onClick' | 'href' | 'to' | 'linkTarget' | 'type'
> & {
  onSubmit?: (data: T) => unknown | Promise<unknown>;
};

export function SubmitButton<T extends AnyObject>({
  onSubmit,
  disabled,
  loading,
  ...props
}: SubmitFormButtonProps<T>) {
  const { handleSubmit, formState } = useFormContext<T>();

  return (
    <Button
      loading={loading || formState.isSubmitting}
      disabled={disabled || formState.disabled}
      round
      type={onSubmit ? 'button' : 'submit'}
      {...props}
      onClick={onSubmit ? handleSubmit(onSubmit) : undefined}
    />
  );
}
